import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Button, Typography } from '@material-ui/core';

let useStyles = makeStyles(theme => ({
  title: {
    fontWeight: 'bold',
    padding: '1rem',
    textAlign: 'center'
  },
  subtitle: {
    fontWeight: 'bold',
    padding: '0.25rem 1rem 1rem 1rem',
    textAlign: 'center'
  }
}));

function Header({ title, onClick, subtitle }) {

  let classes = useStyles();

  return (
    <React.Fragment>
      {onClick ? (
         <Button fullWidth onClick={onClick}>
           <AppBar position="static">
            <Typography variant="h6" className={classes.title}>
              {title}
            </Typography>
            {subtitle ? (
              <Typography variant="h6" className={classes.subtitle}>
                {subtitle}
              </Typography>
            ) : null}
          </AppBar>
        </Button>
      ) : (
        <AppBar position="static">
          <Typography variant="h6" className={classes.title}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="h6" className={classes.subtitle}>
              {subtitle}
            </Typography>
          ) : null}
        </AppBar>
      )}
    </React.Fragment>
  );

}

export default Header;